import { DeviceStatusCheck } from 'app/agriculture/routes/Devices/utils/status/types';

export const checkPower: DeviceStatusCheck<['Power']> = ({ device, snapshots }) => {
    if (device.brand !== 'Yarn') {
        return { messages: [], status: 'success' };
    }

    if (!snapshots.Power) {
        return { messages: ['No power data'], status: 'warning' };
    }

    if (snapshots.Power.status.messages.length > 0) {
        return { messages: snapshots.Power.status.messages, status: 'warning' };
    }

    return { messages: [], status: 'success' };
};
